import { render } from "./MtnCameroonPrizes.vue?vue&type=template&id=48e66fe2&scoped=true"
import script from "./MtnCameroonPrizes.vue?vue&type=script&lang=js"
export * from "./MtnCameroonPrizes.vue?vue&type=script&lang=js"

import "./MtnCameroonPrizes.vue?vue&type=style&index=0&id=48e66fe2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e66fe2"]])

export default __exports__